import mitt from 'mitt';
const eventBus = mitt();
/** 中央事件 */
export default eventBus;
